import {Component, OnInit, Input, OnChanges, Output, EventEmitter} from '@angular/core';
import { Respondent } from '../model/respondent';
import { DataNavigationState } from '../model/data-navigation-state';
import { ProjectService } from '../project/project.service';
import { ClickEvent } from '../project/pagination/pagination.component';
import {Json2TypescriptUtil} from '../util/json2TypescriptUtil';

@Component({
    selector: 'respondents-by-list',
    template: `<div *ngIf="_respondentSelected">
            <respondents-one-by-one [selectedRespondent]="this._selectedRespondent" [navigation-state]="this.navigationState" (backToRespondentList)="backToRespondentList($event)"></respondents-one-by-one>
        </div>
        <div *ngIf="_respondentSelected == false"  style="padding: 10px;">
            <table>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Device ID</th>
                        <th>Date/Time</th>
                        <th>Email Opened</th>
                        <th>Token</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="entries" *ngFor="let respondent of this.respondents" (click)="respondentSelected(respondent.Id)">
                        <td>{{respondent.Id}}</td>
                        <td>{{respondent.DeviceID}}</td>
                        <td>{{respondent.insertedTime}}</td>
                        <td>{{respondent.emailOpened}}</td>
                        <td>{{respondent.token}}</td>
                    </tr>
                </tbody>
            </table>
                    <div class="row col-md-12 containerBox">
                            <div class="paginationComponent">
                                <pagination
                                            [item-can-change]="true"
                                            [indexSelectedItem]="navigationState.paginationNumber"
                                            [item-by-page]="respondents_by_page"
                                            [total-nb-respondents]="_totalNumberOfRespondents"
                                            (beforePageChange)="onBeforePageChange($event)"
                                            (pageChanged)="changePage($event)"
                                            (go)="onBeforePageChange($event)"></pagination>
                            </div>
                    </div>
        </div>
    `,
    styles: [
        `
            .containerBox{height:100px;}
    .entries{
      background-color: lightsteelblue;
    }
    table {width: 100%;table-layout: fixed;}
    tr:nth-child(even){background-color: #a5cafc}
    tr:nth-last-child(odd){background-color: #d4dfea}
    thead tr{background-color: #333c4e;height:50px;}

    thead tr th {color:white; text-align: center;}
    thead tr th:first-child{color:white;border-top-left-radius: 5px;}
    thead tr th:last-child{color:white;border-top-right-radius: 5px;}

    tbody tr{height:35px;}

    tbody tr td{text-align: center;}

    .entries:hover{ background-color: darkkhaki;font-size: large;}

    .paginationComponent{width:fit-content;position: absolute;left:40%;top:10%;}

    .grid-container {
        display: grid;
        grid-template-columns: auto auto auto;
        padding: 10px;
    }
    .grid-item {
        padding: 20px;
        text-align: center;
    }
    tbody tr:last-child td:first-child {border-bottom-left-radius: 5px;}
    tbody tr:last-child td:last-child {border-bottom-right-radius: 5px;}
    `
    ]
})

export class RespondentsByListComponent implements OnInit, OnChanges {

    private respondents: Respondent[] = null;
    @Input('navigation-state') navigationState: DataNavigationState;
    @Input('totalNbRespondents') _totalNumberOfRespondents:number;
    @Input('questionnaireID') _questionnaireId:number;
    @Input('deviceID') _deviceID = -1;
    @Input() respondents_by_page = 25;  // a remplacer par un input
    private _selectedRespondent: Respondent = null;
    private _errorMessage;
    private _pageNumber = 1;

    private _respondentSelected = false;

    @Output() respondentSelect = new EventEmitter<boolean>();

    constructor(private _projectService: ProjectService) {

    }


    ngOnChanges() {
      this.navigateToPage(1);
    }

    ngOnInit() {


        this.respondentSelect.emit(false);
        this.navigationState.paginationNumber = this._pageNumber;
        this.navigateToPage(0);

    }


    private navigateToPage(pageNumber:number) {
        let startIndex:number = pageNumber;
        if(pageNumber!==0) {
            startIndex =  pageNumber-1;
        }

        this.getRespondents(startIndex*this.respondents_by_page,this.respondents_by_page);
        this._respondentSelected= false;
    }

    onBeforePageChange($event:ClickEvent) {
        if ( $event.index > 0  ) {
            this._pageNumber = $event.index;
                this.setPaginationNumber();


            const startIndex = this._pageNumber -1;
            this.getRespondents(startIndex*this.respondents_by_page,this.respondents_by_page);
        }
    }

  // TODO: A component's local pagination should not be handled at application level. Since it is proprietary to this component
  setPaginationNumber() {
        this.navigationState.paginationNumber = this._pageNumber;
    }

    // This method will get the next 20 respondents depending on the total number of respondents available.
    // everytime there will at most 20 respondents
    // TODO: Il faut eventuellement utiliser cet evenment pour montrer le repondant et  changer les pages selon le besoin.
    /*
       Il n'y a pas de concept de repondant actif. Ici tout est passif et il sera dans les dex autres ecrans. On va chercher les repondant via CRUD et le presenter.
       Encore une fois, on utilise le lazy loading pour optiser les ressources disponible.
     */
    changePage($event:number) {

        // once the page is changed, we retrieve the next 20 results (it could be less than 20 if we are at the last page)

        // TODO: Uncomment this later when things will be properly setup
        /*let startIndex = 0 ;
        if(this._pageNumber != 1)
            startIndex = this._pageNumber *this.RESPONDENTS_BY_PAGE;
        this.getRespondents(startIndex,this.RESPONDENTS_BY_PAGE);*/


    }


    private getRespondents(start:number,end:number) {

        this._projectService.getRespondentsByRange(start,end,-1,this.getSynchroID(),-1,this._questionnaireId,-1,false,'','').subscribe((respondents:Respondent[]) => {
              this.respondents = new Array<Respondent>();

              // this.respondents = Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(respondents,Respondent);

            // const jsonConvert = new JsonConvert();
              for(let i = 0; i< respondents.length;i++) {
                    this.respondents.push(Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(respondents[i],Respondent));
              }
            },
           error => this._errorMessage = <any>error);
    }



    respondentSelected(id:number) {
        /*this._projectService.getRespondentsByRange(this._questionnaireId,-1,-1,id,this._synchroId).then( respondent => {
                this._selectedRespondent = new Respondent(respondent[0]);
                this._respondentSelected = true;

            },
            error => this._errorMessage = <any>error);*/

      this._selectedRespondent = this.respondents.filter(r=>(r.Id===id))[0];
      this._respondentSelected = true;
      this.respondentSelect.emit(true);

    }

    backToRespondentList(page:number) {

        this.navigateToPage(page);
        this.respondentSelect.emit(false);
    }


  private getSynchroID():number {
    if(this._deviceID===undefined || this._deviceID===null) {
      return -1;
    } else {
      return this._deviceID;
    }
  }
}
